
import React, { useEffect, useState, useRef } from "react";
import { Accordion, AccordionSummary, Typography, Box, Card, Grid, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { DecorativeCorner } from "../../common/DecorativeCorner";
import { styles } from "../../styles/styles";
import PartnerPreferencesForm from "../Authentication/PartnerPrefrencesForm";
import { matrimoneyEndPoints } from "../../../services/apis";
import axios from "axios";


const PartnerView = (props) => {
    const [partnerData, setProfileData] = useState(props?.partnerData)
    const [expanded, setExpanded] = useState(null);
    const [open, setOpen] = useState(false)
    let getMyProfileData = localStorage.getItem("profileData")
    let MyProfileData = JSON.parse(getMyProfileData)
    let userType = sessionStorage.getItem("userType")
    let Api = useRef(false)
    const [partnerMatchedData, setPartnerMatchedData] = useState({})
    const getCustomerData = async () => {
        try {
            let userType = sessionStorage.getItem("userType")
            let token
            if (userType) {
                token = sessionStorage.getItem("token");
            } else {
                token = localStorage.getItem("token");
            }
            const response = await axios.post(
                matrimoneyEndPoints.VIEW_CUSTOMER_DETAILS,
                { profileId: props?.profileId },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.status) {
                setProfileData(response?.data?.data["Partner Details"])
            }
        } catch (error) {
            console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
        }
    };
    const getPartnerMatchedData = async () => {
        try {
            let userType = sessionStorage.getItem("userType")
            let token
            if (userType) {
                token = sessionStorage.getItem("token");
            } else {
                token = localStorage.getItem("token");
            }
            const response = await axios.post(
                matrimoneyEndPoints.MATCHED_PARTNER_DETAILS,
                { profileId: props?.profileId },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.status) {
                setPartnerMatchedData(response?.data)
            }
        } catch (error) {
            console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
        }
    };
    // useEffect(() => {
    //     getCustomerData()
    //     getPartnerMatchedData()
    // }, [open])
    useEffect(() => {
        if (!Api.current) {
            Api.current = true
            getCustomerData();
            getPartnerMatchedData();
        }
    }, []);
    if (!partnerData) {
        return <p>No profile data available.</p>;
    }
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : null);
    };

    return (
        <Box>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: "flex-end",
                    marginBottom: "10px"
                    // alignItems: 'center',
                    // padding: '10px',
                }}
            >
                {/* <Typography
                    sx={{
                        fontFamily: '"Roboto Condensed", sans-serif',
                        fontWeight: 600,
                        fontSize: '24px',
                        // lineHeight: '100%',
                        letterSpacing: '0%',
                    }}
                >
                    Partner Details
                </Typography> */}

                {((MyProfileData && MyProfileData.id == props?.profileId) || userType) && <Button
                    variant="contained"
                    // onClick={()=>navigate("/profile/education", { state: { type: "edit" } })}
                    onClick={() => setOpen(!open)}

                    sx={{
                        backgroundColor: '#C1721F',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'right',
                        gap: '5px',
                    }}
                >
                    {open ? "View" : "Edit"}
                </Button>}
            </Box>

            {!open ? <Card
                sx={{
                    ...styles.card,
                    height: { xs: "auto", sm: 'auto' },
                    width: "100%",
                    padding: { xs: 2, sm: 4 },
                    borderRadius: "5px"
                }}
            >
                <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                <Box
                    sx={{
                        display: { xs: "center", sm: "flex" },
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        mb: 3,
                    }}
                >
                    {(partnerMatchedData && partnerMatchedData?.status) && <>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 3,
                                p: 2,
                                bgcolor: "#f7e9d3",
                                borderRadius: "16px",
                                width: "fit-content",
                            }}
                        >
                            <Box
                                component="img"
                                src={partnerMatchedData ? partnerMatchedData?.userProfileImage : "/images/men.jpeg"}
                                alt="Left Profile"
                                sx={{
                                    width: { xs: "50px", sm: "80px" },
                                    height: { xs: "50px", sm: "80px" },
                                    borderRadius: "50%",
                                    border: "3px solid #c1721f",
                                    objectFit: "cover",
                                }}
                            />
                            <Box
                                sx={{
                                    width: { xs: "auto", sm: "140px" },
                                    height: { xs: "auto", sm: "110px" },
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#c1721f",
                                    fontSize: "15px",
                                    transform: { xs: "scale(2,2)", sm: "scale(12, 6)" },
                                    lineHeight: 1,
                                }}
                            >
                                ↔
                            </Box>
                            <Box
                                component="img"
                                src={partnerMatchedData ? partnerMatchedData?.partnerProfileImage : "/images/men.jpeg"}
                                alt="Right Profile"
                                sx={{
                                    width: { xs: "50px", sm: "80px" },
                                    height: { xs: "50px", sm: "80px" },
                                    borderRadius: "50%",
                                    border: "3px solid #c1721f",
                                    objectFit: "cover",
                                }}
                            />
                        </Box>

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 3,
                                p: 2,
                                bgcolor: "#f7e9d3",
                                borderRadius: "16px",
                                width: "fit-content",
                            }}
                        >
                            <Typography sx={{
                                color: "green", fontSize: {
                                    xs: "12px", sm: "48px", fontFamily: '"SF Pro Display", sans-serif',
                                }
                            }}>
                                <span>
                                    {partnerMatchedData?.matchSummary?.totalFields ?? 0} / {partnerMatchedData?.matchSummary?.matchedFields ?? 0}
                                    (
                                    {partnerMatchedData?.matchSummary?.matchPercentage ?? 0})
                                </span>

                            </Typography>
                        </Box>
                    </>}
                </Box>
                <Box sx={{
                    width: "100%",
                    margin: "auto",
                    backgroundColor: "white",
                    border: "2px solid #C1721F",
                    padding: { xs: "10px", sm: "50px 50px" },
                    borderRadius: "10px",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
                }}>
                    <Card sx={{ padding: "10px 50px", mb: "0px", borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", border: "3px solid rgba(0, 0, 0, 0.1)" }}>
                        <Typography sx={{ ...styles.viewtextstyle }}>
                            Partner Details
                        </Typography>
                        <Grid container spacing={2} >
                            {partnerData && Object.entries(partnerData).map(([label, value], index) => (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        px: 3,
                                        py: 1.5,
                                        borderBottom: "2px dotted #ccc",
                                    }}
                                >
                                    <Typography
                                        variant="body1"
                                        fontWeight="bold"
                                        sx={{ textAlign: "start", color: "#333", fontSize: "18px" }}
                                    >
                                        {label}
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{ textAlign: "end", color: "#555", maxWidth: "60%" }}
                                    >
                                        {Array.isArray(value)
                                            ? value.length > 0
                                                ? value.join(", ")
                                                : "--"
                                            : value || "--"}
                                    </Typography>
                                </Grid>
                            ))}
                        </Grid>
                    </Card>
                </Box>
            </Card> :
                <>
                    <Box sx={{ width: { xs: "auto", sm: "800px", md: "1405px" }, margin: "auto" }}>
                        <PartnerPreferencesForm type="edit" onSubmitSuccess={() => setOpen(false)} /></Box>
                </>
            }

            {/* </Accordion> */}
        </Box>
    );
};

export default PartnerView;
